<!-- header -->
<header class="main-header">
    <!-- logo-->
    <a routerLinkActive="active" routerLink="" class="logo-holder"><img src="../../assets/images/bim.png" alt="Business in Maharashtra"></a>
    <!-- logo end-->
    <!-- header-search_btn-->
    <div class="header-search_btn show-search-button" (click)="clickEvent()">
        <i class="fal fa-search" [ngClass]="addRemoveClass ? 'vis-head-search-close' : ''"></i>
        <span [ngClass]="addRemoveClass ? 'd-none' : ''">Search</span>
        <span [ngClass]="addRemoveClass ? '' : 'd-none'">Close</span>
    </div>
    <!-- header-search_btn end-->
    <!-- header opt -->

    <span *ngIf="!userIsAuthenticated">
        <a routerLinkActive="active" routerLink="/login" class="add-list color-bg">Login<span><i
                    class="fal fa-user"></i></span></a>
    </span>
    <a *ngIf="ItemCount" routerLinkActive="active" routerLink="cart" class="cart-btn"
        data-microtip-position="bottom" role="tooltip" aria-label="Add Cart"><i class="far fa-shopping-cart"></i><span
            class="cart-counter green-bg"> {{ItemCount}}</span> 
    </a>
    <span *ngIf="userIsAuthenticated">
        <a routerLinkActive="active" (click)="onLogout()" routerLink="" class="add-list color-bg">Logout<span><i
                    class="fal fa-user"></i></span></a>
    </span>
    <!-- header opt end-->
    <!-- After login hide sign and open below-->
    <div class="header-user-menu" *ngIf="userIsAuthenticated">
        <div class="header-user-name" (click)="menuToggleEvent()" [ngClass]="toggleClass ? 'hu-menu-visdec' : ''">
            <span>
                <img [src]="profileImageURL" alt="{{firstName}}">
            </span> 
            Hello , {{firstName}}
        </div>
        <ul class="" [ngClass]="toggleClass ? 'hu-menu-vis' : ''">
            <li><a routerLinkActive="active" routerLink="/dashboard/profile" (click)="menuToggleEvent()">Profile </a></li>
            <li>
                <a routerLinkActive="active" routerLink="/dashboard/post-product" (click)="menuToggleEvent()">Product for Sale</a>
            </li>
            <li><a routerLinkActive="active" routerLink="/dashboard/post-ads" (click)="menuToggleEvent()">Post Live Ads</a></li>
            <li>
                <a routerLinkActive="active" routerLink="/dashboard/my-orders" (click)="menuToggleEvent()">Your Orders</a>
            </li>
            <li><a routerLinkActive="active" routerLink="/dashboard/my-messages" (click)="menuToggleEvent()">Your Enquiry</a></li>
            <li><a routerLinkActive="active" routerLink="/dashboard/my-feeds" (click)="menuToggleEvent()">Your Feed</a></li>

            <li><a routerLinkActive="active" routerLink="" (click)="onLogout()">Log Out</a></li>
        </ul>
    </div>
    <!-- nav-button-wrap-->
    <div class="nav-button-wrap color-bg" (click)="mobileMenuToggle()" [ngClass]="menuClass ? 'vismobmenu_btn' : ''">
        <div class="nav-button">
            <span></span><span></span><span></span>
        </div>
    </div>
    <!-- nav-button-wrap end-->
    <!-- navigation start -->
    <div class="main-menu" [ngClass]="menuClass ? 'vismobmenu' : ''">
        <nav>
            <ul class="no-list-style">
                <li>
                    <a routerLinkActive="" routerLink="" title="Home">Home </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="about" title="About Us">About Us</a>
                </li>
                <li *ngIf="!userIsAuthenticated">
                    <a routerLinkActive="active" routerLink="register" title="Register">Register</a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="contact" title="Contact Us">Contact Us</a>
                </li>
            </ul>
        </nav>
        <nav class="menusb sliding-menu">
            <div class="sliding-menu-wrapper" style="width: 279px;">
                <ul class="no-list-style menu-panel-root" style="width: 279px;">
                    <li>
                        <a routerLinkActive="active" routerLink="" title="Home">Home </a>
                    </li>
                    <li>
                        <a routerLinkActive="active" routerLink="about" title="About Us">About Us</a>
                    </li>
                    <li *ngIf="!userIsAuthenticated">
                        <a routerLinkActive="active" routerLink="register" title="Register">Register</a>
                    </li>
                    <li>
                        <a routerLinkActive="active" routerLink="contact" title="Contact Us">Contact Us</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
    <!-- navigation  end -->
    <!-- header-search_container -->
    <div class="header-search_container header-search" [ngClass]="addRemoveClass ? 'vis-head-search' : 'vis-search'">
        <div class="container small-container">
            <div class="header-search-input-wrap fl-wrap">
                <form [formGroup]="form">
                    <!-- header-search-input -->
                    <div class="header-search-input header-search_selectinpt">
                        <span class="listsearch-input-item">
                            <select class="form-select" formControlName="selectedType" #selectedType data-placeholder="Select Type">
                                <option [value]="null">-- Select Type --</option>
                                <option value="business">Business</option>
                                <option value="products">Products</option>
                                <!-- <option value="advertising">Advertising</option> -->
                            </select>
                        </span>
                    </div>
                    <!-- header-search-input end -->
                    <!-- header-search-input -->
                    <div class="header-search-input">
                        <label><i class="fal fa-keyboard"></i></label>
                        <input type="text" formControlName="searchString" #searchString placeholder="What are you looking for ?" value="" />
                    </div>
                    <!-- header-search-input end -->
                    <!-- header-search-input -->
                    <div class="header-search-input header-search_selectinpt ">
                        <span class="listsearch-input-item">
                            <select class="form-select" formControlName="selectedCategory" #selectedCategory data-placeholder="All Categories">
                                <option [value]="null">-- Select Category --</option>
                                <option *ngFor="let category of categories" [value]="category.id">
                                    {{ category.name }}
                                </option>
                            </select>
                        </span>
                    </div>
                    <!-- header-search-input end -->
                    <!-- <button class="header-search-button green-bg" [routerLink]="['/search', this.selectedType, this.searchString,this.selectedCategory]"><i class="far fa-search"></i> Search </button> -->
                    <button class="header-search-button green-bg" type="submit" (click)="onClickToSearch(selectedType.value, selectedCategory.value, searchString.value)"><i class="far fa-search"></i> Search </button>
                </form>
            </div>
            <div class="header-search_close color-bg" (click)="clickEvent()"><i class="fal fa-long-arrow-up"></i></div>
        </div>
    </div>
    <!-- header-search_container  end -->
</header>
<!-- header end-->